import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SectionRelatedContentBlockContainerModule } from '@dynamic-components/section-related-content-block-container';
import { DotBackgroundOverlayModule } from '@shared/dot-background-overlay/dot-background-overlay.module';
import { JbBackgroundImageModule } from 'jb-component-library';

import { JBSectionContainerModule } from '../section-container/section-container.module';
import {
  SectionHeaderContainerComponent,
  sectionHeaderContainerResolver,
} from './section-header-container.component';

const MODULES = [
  CommonModule,
  JBSectionContainerModule,
  SectionRelatedContentBlockContainerModule,
  JbBackgroundImageModule,
  DotBackgroundOverlayModule,
];

const DECLARATIONS = [SectionHeaderContainerComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class SectionHeaderContainerModule {
  static entry = SectionHeaderContainerComponent;
  static componentDataResolver = sectionHeaderContainerResolver;
}
